export default __webpack_public_path__ + "static/media/570.df4d7990.gif";